import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatterDocumentType, MatterFile } from '@models/matter-file';
import {
	DocumentProcessingLoadingKey,
	DocumentProcessorService,
} from '@services/document-ai/document-processor.service';
import { EMPTY, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-matter-file-card',
	templateUrl: './matter-file-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterFileCardComponent {
	public _matterDocumentType: DocumentProcessingLoadingKey;
	public isOCRProcessing$: Observable<boolean> = EMPTY;
	public _matterFile: MatterFile;
	@Input() set matterFile(matterFile: MatterFile) {
		this._matterFile = matterFile;
		this._matterDocumentType = [
			MatterDocumentType.ADDITIONAL_REGISTER,
		].includes(matterFile.type)
			? `${matterFile.type}:${matterFile.systemTags[0].split(':')[1]}`
			: matterFile.type;

		this.isOCRProcessing$ = this.documentProcessingService.isLoading$(
			this._matterDocumentType,
		);
	}

	@Output() onClick = new EventEmitter<void>();

	constructor(private documentProcessingService: DocumentProcessorService) {}

	clickHandler() {
		this.isOCRProcessing$.pipe(take(1)).subscribe((isProcessing) => {
			if (!isProcessing) {
				this.onClick.emit();
			}
		});
	}
}
